export function getDeviceQuality() {
  const isSmallScreen = typeof window !== "undefined" && window.innerWidth < 768;
  const cores =
    typeof navigator !== "undefined" && navigator.hardwareConcurrency
      ? navigator.hardwareConcurrency
      : 8;
  const isLowPower = cores <= 4 || isSmallScreen;

  return {
    tier: isLowPower ? "low" : "high",
    particleCount: isLowPower ? 400 : 1400,
    dpr: isLowPower ? [1, 1.3] : [1, 2],
    bloomIntensity: isLowPower ? 0.7 : 1.4,
    shadows: !isLowPower,
    buildingDetail: isLowPower ? "low" : "high",
  };
}

export function supportsWebGL2() {
  try {
    const canvas = document.createElement("canvas");
    return !!canvas.getContext("webgl2");
  } catch (e) {
    return false;
  }
}
